import Rete from "rete";
import {ToggleControl, ToggleSocket } from "../../rete-controls/ToggleControl.js"
import AnyTypeSocket, { BooleanSocket } from "../../../Utils/CommonSockets.js";

export default class ToggleComponent extends Rete.Component {
  constructor() {
    super("Fire On"); // name
    this._categories = ["Conditionals", "Simulator", "tryMe"];
  }

  builder(node) {
    var inp1 = new Rete.Input("in1", "IN", AnyTypeSocket);
    var inp2 = new Rete.Input("in2", "Yes/No", BooleanSocket);

    var out1 = new Rete.Output("out1", "OUT", AnyTypeSocket);

    let toggleControl = new ToggleControl(this.editor, "fire", "Fire On Yes","Fire On No");

    return node
    .addInput(inp1)
    .addInput(inp2)
    .addOutput(out1)
      .addControl(toggleControl);
  }

  worker(node, inputs, outputs) {
    let a = inputs["in1"];
    let trigger = inputs["in2"];
    let fireOnTrue = node.data.fire;
    fireOnTrue = fireOnTrue == undefined ? false : fireOnTrue;
    if (trigger.length !== 0 && a.length !== 0) {
        a = a[0];    
        trigger = trigger[0];
        if((fireOnTrue == true && trigger == true) ||
           (fireOnTrue == false && trigger == false) )
        outputs['out1'] = a;    
    }


  }
}

//ReteComponentStore.add(new NumberAdderComponent());